import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { FormControl, FormGroup, NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { DealMutationService } from '../../../../services/dealMutation.service'
import { debounceTime, filter, pluck } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router'
import { LesseeCompany } from 'modules/deals/utilities/deal-types'
import { TenantService } from 'framework/tenant/tenant.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-configuration-option-company-form',
    templateUrl: './configuration-option-company-form.component.html',
    styleUrls: ['./configuration-option-company-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ConfigurationOptionCompanyForm),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ConfigurationOptionCompanyForm),
            multi: true,
        },
    ],
})

/* eslint-disable-next-line  @angular-eslint/component-class-suffix */
export class ConfigurationOptionCompanyForm implements OnInit {
    configurationId: string
    form: FormGroup
    noKvkService: boolean = false

    hasCheckout: boolean

    needsChamberOfCommerceNumber: boolean

    @Input()
    initialLessee: LesseeCompany

    constructor(
        private dealMutationService: DealMutationService,
        private route: ActivatedRoute,
        private tenantService: TenantService
    ) {}

    ngOnInit() {
        this.hasCheckout = this.tenantService.hasCheckout$.getValue()
        this.noKvkService = !this.tenantService.hasChamberOfCommerceService$.getValue()
        this.needsChamberOfCommerceNumber = this.tenantService.needsChamberOfCommerceNumber$.getValue()

        this.route.parent.data
            .pipe(untilDestroyed(this), pluck<any, string>('configurationId'), filter(Boolean))
            .subscribe((id: string) => {
                this.configurationId = id
            })

        this.form = new FormGroup({
            ...(this.needsChamberOfCommerceNumber
                ? { chamberOfCommerceNr: new FormControl(this.initialLessee?.chamberOfCommerceNr || '') }
                : {}),
            name: new FormControl(this.initialLessee?.name || ''),
            street: new FormControl(this.initialLessee?.postalAddress?.street || ''),
            houseNumber: new FormControl(this.initialLessee?.postalAddress?.houseNumber || ''),
            houseNumberSuffix: new FormControl(this.initialLessee?.postalAddress?.houseNumberSuffix || ''),
            zipcode: new FormControl(this.initialLessee?.postalAddress?.zipcode || ''),
            city: new FormControl(this.initialLessee?.postalAddress?.city || ''),
        })

        this.form.valueChanges.pipe(untilDestroyed(this), debounceTime(300)).subscribe(formValue => {
            if (this.shouldUpdateDealLessee(formValue)) {
                this.dealMutationService.updateDealLessee(this.configurationId, formValue)
            }
        })
    }

    onCompanySelected({ address, chamberOfCommerceNr, name }) {
        this.form.setValue({
            chamberOfCommerceNr,
            name,
            street: address.street,
            houseNumber: address.houseNr,
            houseNumberSuffix: address.houseNrSuffix,
            zipcode: address.zipCode,
            city: address.city,
        })
    }

    shouldUpdateDealLessee(formValue: any): boolean {
        if (this.hasCheckout) {
            return (
                (!this.needsChamberOfCommerceNumber || formValue.chamberOfCommerceNr) &&
                formValue.name &&
                formValue.street &&
                formValue.houseNumber &&
                formValue.zipcode &&
                formValue.city
            )
        }

        return !!formValue.name
    }
}
